<template>
    <div class="claim-total-head">
        <div class="predict flex-grow-2">
          <div class="flex align-center flex1">
            <gj-tooltip :content="tipMap[type].estimateClaimQuantity">
              <div class="icon1">
                <i  class="iconfont iconsuopei-04 size20 icon-color1"></i>
              </div>
              <div>
                <div class="title1">预计赔付数量</div>
                <div class="detail1" :title="amountSymbol(totalObj.estimateClaimQuantity, 0).origin || ''">
                  {{ amountSymbolFormat(totalObj.estimateClaimQuantity, 0) | defaultShow}}
                </div>
              </div>
            </gj-tooltip>
          </div>
          <div class="flex align-center flex1">
            <gj-tooltip :content="tipMap[type].estimateClaimMoney">
              <div class="icon1 icon-bg1">
                <i  class="iconfont iconsuopei-01 size20 icon-color1"></i>
              </div>
              <div >
                <div class="title1">预计赔付金额</div>
                <div class="detail1" :title="amountSymbol(totalObj.estimateClaimMoney).origin ? (totalObj.currencySymbol || '') + amountSymbol(totalObj.estimateClaimMoney).origin : ''">
                    {{totalObj.currencySymbol || ''}}{{ amountSymbolFormat(totalObj.estimateClaimMoney) | defaultShow}}
                </div>
              </div>
            </gj-tooltip>
          </div>
        </div>
        <div class="predict gj-mlr20 flex-grow-3">
          <div class="flex align-center flex1">
            <gj-tooltip :content="tipMap[type].realClaimQuantity">
              <div class="icon1 icon-bg2">
                <i  class="iconfont iconsuopei-03  size20 icon-color2"></i>
              </div>
              <div >
                <div class="title1">已赔付库存量</div>
                <div class="detail1" :title="amountSymbol(totalObj.realClaimQuantity, 0).origin || ''">
                  {{ amountSymbolFormat(totalObj.realClaimQuantity, 0) | defaultShow}}
                </div>
              </div>
            </gj-tooltip>
          </div>
          <div class="flex align-center flex1">
            <gj-tooltip :content="tipMap[type].realClaimCashQuantity">
              <div class="icon1 icon-bg3">
                <i  class="iconfont iconsuopei-04 size20 icon-color3"></i>
              </div>
              <div >
                <div class="title1">已赔付金额量</div>
                <div class="detail1" :title="amountSymbol(totalObj.realClaimCashQuantity).origin ? amountSymbol(totalObj.realClaimCashQuantity, 0).origin : ''">
                  {{ amountSymbolFormat(totalObj.realClaimCashQuantity, 0) | defaultShow}}
                </div>
              </div>
            </gj-tooltip>
          </div>
          <div class="flex align-center flex1">
            <gj-tooltip :content="tipMap[type].realClaimMoney">
              <div class="icon1 icon-bg3">
                <i  class="iconfont iconsuopei-01 size20 icon-color3"></i>
              </div>
              <div >
                <div class="title1">已赔付金额</div>
                <div class="detail1" :title="amountSymbol(totalObj.realClaimMoney).origin ? (totalObj.currencySymbol || '') + amountSymbol(totalObj.realClaimMoney).origin : ''">
                  {{totalObj.currencySymbol || ''}}{{ amountSymbolFormat(totalObj.realClaimMoney) | defaultShow}}
                </div>
              </div>
            </gj-tooltip>
          </div>
        </div>
        <div class="predict flex-grow-1">
          <div class="flex align-center flex1">
            <gj-tooltip :content="tipMap[type].toDayCaseQuantity">
              <div class="icon1 icon-bg4">
                <i  class="iconfont iconsuopei-04 size20 icon-color4"></i>
              </div>
              <div >
                <div class="title1">今日已开case数量</div>
                <div class="detail1" :title="amountSymbol(totalObj.toDayCaseQuantity, 0).origin || ''">
                  {{ amountSymbolFormat(totalObj.toDayCaseQuantity, 0) | defaultShow}}
                </div>
              </div>
            </gj-tooltip>
          </div>
        </div>
      </div>
</template>

<script>
import {isMeaningless} from "@/utils/common";
import {amountSymbol} from "@/filters";
export default {
  name: "claim-total-head",
  props: {
    totalObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: 'inventoryClaim'
    }
  },

  data() {
    return {
      tipMap: {
        'inventoryClaim': {
          estimateClaimQuantity: '当前查询条件下，预计总共需要向亚马逊索赔的残损商品、丢失商品的总数量',
          estimateClaimMoney: '当前查询条件下，预计总共需要向亚马逊索赔的残损商品、丢失商品的总金额',
          realClaimQuantity: '当前查询条件下，亚马逊实际已赔付库存的总商品数量',
          realClaimCashQuantity: '当前查询条件下，亚马逊实际已赔付金额的总商品数量',
          realClaimMoney: '当前查询条件下，亚马逊实际已赔付的总金额',
          toDayCaseQuantity: '今日已开case数量的总和；仅受仓库查询条件影响'
        },
        'returnClaim': {
          estimateClaimQuantity: '当前查询条件下，预计总共需要向亚马逊索赔的未退回商品、残损商品的总数量',
          estimateClaimMoney: '当前查询条件下，预计总共需要向亚马逊索赔的未退回商品、残损商品的总金额',
          realClaimQuantity: '当前查询条件下，亚马逊实际已赔付库存的总商品数量',
          realClaimCashQuantity: '当前查询条件下，亚马逊实际已赔付金额的总商品数量',
          realClaimMoney: '当前查询条件下，亚马逊实际已赔付的总金额',
          toDayCaseQuantity: '今日已开case数量的总和；仅受国家、店铺查询条件影响'
        },
        'shipmentClaim': {
          estimateClaimQuantity: '当前查询条件下，预计总共需要向亚马逊索赔的丢失商品的总数量',
          estimateClaimMoney: '当前查询条件下，预计总共需要向亚马逊索赔的丢失商品的总金额',
          realClaimQuantity: '当前查询条件下，亚马逊实际已赔付库存的总商品数量',
          realClaimCashQuantity: '当前查询条件下，亚马逊实际已赔付金额的总商品数量',
          realClaimMoney: '当前查询条件下，亚马逊实际已赔付的总金额',
          toDayCaseQuantity: '今日已开case数量的总和；仅受国家、店铺查询条件影响'
        }
      }
    }
  },

  methods: {
    amountSymbol,
    amountSymbolFormat(val, digit = 2) {
      if (isMeaningless(val)) {
        return '-';
      }

      if (isNaN(val)) {
        return val;
      }
      let amountSymbol = this.amountSymbol(val, digit)
      if(Number(val) >= 1e6) {
        return (amountSymbol.value + amountSymbol.unit)
      }else{
        return amountSymbol.origin
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .claim-total-head{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 10px;
    .predict{
      display: flex;
      flex-direction: row;
      background: #FFFFFF;
      border: 1px solid #E4E5E6;
      border-radius: 4px;
      align-items: center;
      box-sizing: border-box;
      height: 80px;
      padding: 16px 24px 12px 24px;
      .icon1{
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFFBE8;
        border-radius: 4px;
      }

      .icon-color1{
        color: #FAD20C;
      }

      .icon-color2{
        color: #1F6EEF;
      }

      .icon-color3{
        color: #F5222D;
      }

      .icon-color4{
        color: #8A3FD4;
      }

      .icon-bg1{
        background: #FFFBE8;
      }
      .icon-bg2{
        background: #EDF4FF;
      }
      .icon-bg3{
        background: #FFF4F5;
      }
      .icon-bg4{
        background: #FAF4FF;
      }
      .title1{
        height: 20px;

        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
        margin-left: 20px;
      }
      .detail1{
        font-family: 'Helvetica';
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        margin-top: 4px;
        margin-left: 20px;
        color: #333333;
      }
      .title2{
        position: absolute;
        height: 20px;
        left: 23.57%;
        right: 70.28%;
        top: calc(50% - 20px/2 - 210px);
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
    }
  }
  .flex-grow-1 {
    flex-grow: 1;
  }
  .flex-grow-2 {
    flex-grow: 2;
  }
  .flex-grow-3 {
    flex-grow: 3;
  }
</style>